import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSend = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.451 3.24898C20.6819 3.47988 20.7602 3.82262 20.6523 4.13082L15.0523 20.1308C14.9372 20.4598 14.6329 20.6851 14.2847 20.6993C13.9364 20.7135 13.6148 20.5137 13.4733 20.1952L10.406 13.294L3.50479 10.2268C3.18631 10.0852 2.9865 9.7636 3.00071 9.41537C3.01492 9.06715 3.24026 8.76288 3.56921 8.64774L19.5692 3.04774C19.8774 2.93987 20.2202 3.01809 20.451 3.24898ZM12.0638 12.8383L14.156 17.5456L17.8173 7.08486L12.0638 12.8383ZM16.6152 5.88277L6.15442 9.54404L10.8618 11.6362L16.6152 5.88277Z"
        />
      </svg>
    );
  }
);
